import React from "react";
import { Navigate } from "react-router-dom";
const AdminPublicRoute = ({ children }) => {
    const isSuperAdmin = sessionStorage.getItem("isAdmin")
    const temp = sessionStorage.getItem("name");
    console.log(isSuperAdmin,"xnkdbvjcb")

    if (temp) {
        if (isSuperAdmin) {
            return <Navigate to='/merchant-list' />
        }
        else {
              return <Navigate to="/dashboard" />;
        }
      
    }


    return children;
};

export default AdminPublicRoute;
